
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Edit2, Trash2, MoreVertical, Loader2 } from "lucide-react";

interface FAQActionsProps {
  isEditing: boolean;
  isLoading: boolean;
  onEdit: () => void;
  onDelete: () => void;
}

export const FAQActions = ({ isEditing, isLoading, onEdit, onDelete }: FAQActionsProps) => {
  if (isEditing || isLoading) {
    return (
      <div className="flex items-center justify-center w-8 h-8 sm:w-9 sm:h-9">
        {isLoading && <Loader2 className="h-3 w-3 sm:h-4 sm:w-4 animate-spin text-muted-foreground" />}
      </div>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          size="sm" 
          className="h-8 w-8 sm:h-9 sm:w-9 p-0 hover:bg-muted touch-manipulation"
          onClick={(e) => e.stopPropagation()}
        >
          <MoreVertical className="h-3 w-3 sm:h-4 sm:w-4" />
          <span className="sr-only">Open menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        <DropdownMenuItem onClick={onEdit} className="cursor-pointer">
          <Edit2 className="h-4 w-4 mr-2" />
          Edit
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={onDelete} 
          className="cursor-pointer text-destructive focus:text-destructive"
        >
          <Trash2 className="h-4 w-4 mr-2" />
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
